var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      class: _vm.fullscreen ? "t-dialog--fullscreen" : "t-dialog",
      attrs: {
        fullscreen: _vm.fullscreen,
        visible: _vm.dialogVisible,
        "custom-class": "view-dialog",
        width: "65%",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
        close: function ($event) {
          return _vm.$emit("close")
        },
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "t__dialog__header",
          attrs: { slot: "title" },
          slot: "title",
        },
        [
          _c("div", { staticClass: "flex-row" }, [
            _c("span", { staticClass: "el-dialog__title" }, [
              _vm._v(_vm._s(_vm.dialogTitle)),
            ]),
            !_vm.isEditMode
              ? _c(
                  "div",
                  { staticClass: "status_box" },
                  [
                    _c("i", {
                      class: _vm.formModel.asterisk
                        ? "el-icon-star-on"
                        : "el-icon-star-off",
                      on: {
                        click: function ($event) {
                          return _vm.handleStatusClick(
                            _vm.formModel.asterisk ? "cancelStar" : "setStar"
                          )
                        },
                      },
                    }),
                    _c(
                      "span",
                      {
                        class: _vm.formModel.processingStatus
                          ? "item_check"
                          : "item_check processed-not",
                        on: {
                          click: function ($event) {
                            return _vm.handleStatusClick(
                              _vm.formModel.processingStatus
                                ? "cancelProcessed"
                                : "setProcessed"
                            )
                          },
                        },
                      },
                      [
                        _c("i", {
                          staticClass: "el-icon-check",
                          staticStyle: { margin: "0 auto" },
                        }),
                      ]
                    ),
                    _c("svg-icon", {
                      attrs: {
                        itemId: "records",
                        name: _vm.formModel.hasRemark
                          ? "message"
                          : "message_default",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.handleStatusClick("records")
                        },
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ]),
          _c("div", { staticClass: "t__dialog__menu" }, [
            _c("i", {
              staticClass: "el-dialog__close",
              class: _vm.fullscreen ? "el-icon-news" : "el-icon-full-screen",
              on: { click: _vm.handleFullScreen },
            }),
          ]),
        ]
      ),
      _c(
        "el-row",
        {
          staticClass: "dialog-form",
          style: { height: _vm.dialogHeight + "px" },
        },
        [
          _c(
            "el-col",
            {
              staticClass: "left",
              style: { height: _vm.dialogHeight + "px" },
              attrs: { span: 18, xs: 24 },
            },
            [
              _c(
                "el-scrollbar",
                [
                  _vm.formConf.fields.length && _vm.formModel && _vm.isEditMode
                    ? _c("generate-form", {
                        key: _vm.formParseKey,
                        ref: "generateForm",
                        staticStyle: { "margin-bottom": "40px" },
                        attrs: {
                          "form-conf": _vm.formConf,
                          "page-form-model": _vm.formModel,
                        },
                      })
                    : _c("view-data", {
                        attrs: {
                          id: "printForm",
                          fields: _vm.fields,
                          "page-form-model": _vm.formModel,
                          "is-print": _vm.isPrint,
                        },
                        on: {
                          "update:isPrint": function ($event) {
                            _vm.isPrint = $event
                          },
                          "update:is-print": function ($event) {
                            _vm.isPrint = $event
                          },
                        },
                      }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { staticClass: "right", attrs: { span: 6, xs: 24 } },
            [
              _c(
                "el-descriptions",
                { attrs: { column: 1, title: "基础信息" } },
                _vm._l(_vm.fixedFields, function (field) {
                  return _c(
                    "el-descriptions-item",
                    { key: field.value, attrs: { label: field.label } },
                    [
                      field.value === "submitUaOs"
                        ? _c("span", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.formModel.submitUa
                                    ? _vm.formModel.submitUa.os.name
                                    : ""
                                ) +
                                " " +
                                _vm._s(
                                  _vm.formModel.submitUa
                                    ? _vm.formModel.submitUa.os.version
                                    : ""
                                ) +
                                " "
                            ),
                          ])
                        : _vm._e(),
                      field.value === "submitUaDevice"
                        ? _c("span", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.formModel.submitUa
                                    ? _vm.formModel.submitUa.device
                                    : ""
                                ) +
                                " "
                            ),
                          ])
                        : _vm._e(),
                      field.value === "wxUserInfo"
                        ? _c("span", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.formModel.wxUserInfo
                                    ? _vm.formModel.wxUserInfo.nickname
                                    : ""
                                ) +
                                " "
                            ),
                            _c("div", [
                              _vm._v(
                                _vm._s(
                                  _vm.formModel.wxUserInfo
                                    ? _vm.formModel.wxUserInfo.openid
                                    : ""
                                )
                              ),
                            ]),
                          ])
                        : _vm._e(),
                      field.value === "submitBrowser"
                        ? _c("span", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.formModel.submitUa
                                    ? _vm.formModel.submitUa.browser.name
                                    : ""
                                ) +
                                " " +
                                _vm._s(
                                  _vm.formModel.submitUa
                                    ? _vm.formModel.submitUa.browser.version
                                    : ""
                                ) +
                                " "
                            ),
                          ])
                        : _c("span", [
                            _vm._v(
                              " " + _vm._s(_vm.formModel[field.value]) + " "
                            ),
                          ]),
                    ]
                  )
                }),
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "t-dialog__footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _vm.isEditMode
            ? _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.handleUpdate } },
                [_vm._v(" 确 定 ")]
              )
            : _vm._e(),
          _c("el-button", { on: { click: _vm.handleCancel } }, [
            _vm._v("取 消"),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }